<template>
<div class="chapter">
<div class="inner_page">
<p class="ct"><a id="page5"></a><strong>Contents</strong></p>
<p class="toc"><a href="#/xhtml/introduction"><strong>Introduction</strong></a></p>
<p class="toc1"><a href="#/xhtml/ch001"><strong>Chapter 1</strong> The Ritual: Custom and Chaos</a></p>
<p class="toc1"><span href="#/xhtml/ch002" title="Link target outside of Sample"><strong>Chapter 2</strong> A Short History of Capital Punishment in England since c.1800</span></p>
<p class="toc2"><span href="#/xhtml/part001" title="Link target outside of Sample"><strong>Part One: Hangmen employed in Yorkshire</strong></span></p>
<p class="toc1"><span href="#/xhtml/ch003" title="Link target outside of Sample"><strong>Chapter 3</strong> Curry and other York Hangmen</span></p>
<p class="toc1"><span href="#/xhtml/ch004" title="Link target outside of Sample"><strong>Chapter 4</strong> Bartholomew Binns</span></p>
<p class="toc1"><span href="#/xhtml/ch005" title="Link target outside of Sample"><strong>Chapter 5</strong> James Berry</span></p>
<p class="toc1"><span href="#/xhtml/ch006" title="Link target outside of Sample"><strong>Chapter 6</strong> James Billington and Some Curiosities</span></p>
<p class="toc1"><span href="#/xhtml/ch007" title="Link target outside of Sample"><strong>Chapter 7</strong> Henry Pierrepoint</span></p>
<p class="toc1"><span href="#/xhtml/ch008" title="Link target outside of Sample"><strong>Chapter 8</strong> Thomas Pierrepoint</span></p>
<p class="toc1"><span href="#/xhtml/ch009" title="Link target outside of Sample"><strong>Chapter 9</strong> Albert Pierrepoint</span></p>
<p class="toc1"><span href="#/xhtml/ch010" title="Link target outside of Sample"><strong>Chapter 10</strong> Steve Wade</span></p>
<p class="toc2"><span href="#/xhtml/part002" title="Link target outside of Sample"><strong>Part two: Obscure Figures and Dark Tales</strong></span></p>
<p class="toc1"><span href="#/xhtml/ch011" title="Link target outside of Sample"><strong>Chapter 11</strong> Some Assistants</span></p>
<p class="toc1"><span href="#/xhtml/ch012" title="Link target outside of Sample"><strong>Chapter 12</strong> Some Tales of Bad Workmanship</span></p>
<p class="toc1"><span href="#/xhtml/conclusion" title="Link target outside of Sample"><strong>Conclusions</strong></span></p>
<p class="toc1"><span href="#/xhtml/biblo" title="Link target outside of Sample"><strong>Selected Bibliography</strong></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?7a644d06